import React, { useState, useEffect } from 'react';
import { withStyles, WithStyles, createStyles, Theme } from '@material-ui/core/styles';
import { KeyboardArrowDown as KeyboardArrowDownIcon, KeyboardArrowUp as KeyboardArrowUpIcon } from '@material-ui/icons';

const useStyles = (theme: Theme) =>
  createStyles({
    arrow: {
      color: theme.palette.primary.main,
    },
  });

interface SelectArrowProps extends WithStyles<typeof useStyles> {
  arrowProps: Record<string, unknown>;
}

const SelectArrow: React.FC<SelectArrowProps> = ({ arrowProps, classes }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    /* The arrow component on react-select is changing on mouseDown,
    instead on onClick event, because of that, the arrow component changes fast and gets double clicked,
     opening and closing the SelectField with its options.

     Because of that, I added a local state and a setTimeout to avoid that rerender
     */
    // TODO: Update react-select to v4
    setTimeout(() => setIsOpen(!!arrowProps.isOpen));
  }, [arrowProps, setIsOpen]);

  if (isOpen) {
    return <KeyboardArrowUpIcon className={classes.arrow} />;
  }

  return <KeyboardArrowDownIcon className={classes.arrow} />;
};

export default withStyles(useStyles)(SelectArrow);
